module.exports = __webpack_public_path__ + "img/artstart.7edbf122.png";